import { createReducer, createSetter } from "@/redux/helpers/reducer";
import { STATUS } from "@/utils/constants";

import * as actions from "./attachments-section.actions";

const initialState = {
  isFetchingAttachmentsStatus: STATUS.IDLE,
  attachments: [],
  selectedAttachments: [],
  isAttachmentsLoading: false,
};

export default createReducer(initialState, {
  [actions.setIsFetchingAttachmentsStatus]: createSetter("isFetchingAttachmentsStatus"),
  [actions.setIsAttachmentsLoading]: createSetter("isAttachmentsLoading"),
  [actions.setAttachments]: createSetter("attachments"),
  [actions.setSelectedAttachments]: createSetter("selectedAttachments"),
  [actions.reset]: () => ({ ...initialState }),
});
